import { money } from '../components/QuantityStepper'

const PRICE_PATTERN = /\$[\d,]+(?:\.\d{2})?/

/** Swaps the price shown in a buy-button label for the card's live total (base + add-ons). */
export function withPrice(label: string, total: number): string {
  const price = money(total)
  // A replacer function is required: a plain string like "$179.90" would be read by
  // String.replace as the "$1" group reference and print garbage such as ".9079.90".
  return PRICE_PATTERN.test(label) ? label.replace(PRICE_PATTERN, () => price) : `${label} — ${price}`
}
